// DateFilterContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const DateFilterContext = createContext();

export function DateFilterProvider({ children }) {
    // Initialize from sessionStorage, NOT from an empty string
    const [navigationDate, setNavigationDate] = useState(() => {
        return sessionStorage.getItem("navigationDate") || "";
    });

    // Persist to sessionStorage whenever navigationDate changes
    useEffect(() => {
        if (navigationDate) {
            sessionStorage.setItem("navigationDate", navigationDate);
        } else {
            sessionStorage.removeItem("navigationDate");
        }
    }, [navigationDate]);

    // Listen for storage changes from other tabs/windows
    useEffect(() => {
        const handleStorageChange = (e) => {
            if (e.key === "navigationDate") {
                setNavigationDate(e.newValue || "");
            }
        };
        window.addEventListener("storage", handleStorageChange);
        return () => window.removeEventListener("storage", handleStorageChange);
    }, []);

    return (
        <DateFilterContext.Provider value={{ navigationDate, setNavigationDate }}>
            {children}
        </DateFilterContext.Provider>
    );
}

export function useDateFilter() {
    return useContext(DateFilterContext);
}